import React, { useState, useEffect, useCallback } from 'react';
import {
  C, S, Badge, StatusBadge, FormField, ErrList, StatCard,
  PageHeader, FilterBar, DataTable, Modal, FormGrid,
  useToast, useConfirm, useCRUD,
} from '../../components/inventoryShared';
import {
  categoryController, subCategoryController, brandController,
  unitController, productController, warehouseController,
  locationController, supplierController, purchaseOrderController,
  purchaseReturnController, stockInController, stockOutController,
  stockTransferController, stockAdjustmentController,
  stockController, reportController,
} from '../../controllers/inventoryController';
import {
  Tag, Layers, Boxes, Settings, Package, BarChart3,
  PackageCheck, TrendingDown, ArrowLeftRight, ClipboardList,
  Users, ShoppingCart, RotateCcw, Warehouse, MapPin,
  AlertTriangle, Receipt, FileText, QrCode, Plus,
  Edit2, Trash2, Eye, Download, RefreshCw, CheckCircle,
  XCircle, Truck, ChevronDown, ChevronUp, Search,
} from 'lucide-react';
import makeSimplePage from './makeSimplePage';
import ActionBtns from './ActionBtns';
const fmt   = (d) => d ? new Date(d).toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' }) : '—';
const money = (v) => `₹${Number(v || 0).toLocaleString('en-IN')}`;

// ─────────────────────────────────────────────────────────────────────────────
// Compact page factory for simpler pages
// ─────────────────────────────────────────────────────────────────────────────

// ─────────────────────────────────────────────────────────────────────────────
// 14. STOCK ADJUSTMENT PAGE
// ─────────────────────────────────────────────────────────────────────────────
export const StockAdjustmentPage = makeSimplePage({
  title:'Stock Adjustment', subtitle:'Adjust stock quantities', Icon:ClipboardList, color:C.warning,
  ctrl:stockAdjustmentController, emptyTitle:'No adjustments found',
  statusOptions:['Draft','Pending','Approved','Rejected'],
  defaultForm:{ warehouseId:'',warehouseName:'',date:new Date().toISOString().split('T')[0],type:'Physical Count',items:[],reason:'',adjustedBy:'',status:'Draft',notes:'' },
  columns:(crud,openEdit)=>[
    { label:'Adj. No.', key:'adjustmentNumber', render:v=><span style={{ fontFamily:'monospace', fontSize:12, color:C.warning }}>{v||'—'}</span> },
    { label:'Type', key:'type', render:v=><Badge color={C.warning} bg={`${C.warning}15`}>{v}</Badge> },
    { label:'Warehouse', key:'warehouseName', render:v=>v||'—' },
    { label:'Date', key:'date', render:v=>fmt(v) },
    { label:'Reason', key:'reason', render:v=><div style={{ maxWidth:180, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', fontSize:12 }}>{v||'—'}</div> },
    { label:'Adjusted By', key:'adjustedBy', render:v=>v||'—' },
    { label:'Status', key:'status', render:v=><StatusBadge status={v}/> },
    { label:'', key:'actions', render:(_, r)=><ActionBtns onEdit={()=>openEdit(r)} onDelete={()=>crud.handleDelete(r.id,'this adjustment')} /> },
  ],
  formFields:(f,set)=>[
    <FormField key="type" label="Adjustment Type"><select style={S.select} value={f.type} onChange={e=>set('type',e.target.value)}>{['Physical Count','Damage','Expiry','Theft','System Correction','Other'].map(t=><option key={t}>{t}</option>)}</select></FormField>,
    <FormField key="wn" label="Warehouse Name *"><input style={S.input} value={f.warehouseName} onChange={e=>set('warehouseName',e.target.value)} /></FormField>,
    <FormField key="dt" label="Date *"><input type="date" style={S.input} value={f.date} onChange={e=>set('date',e.target.value)} /></FormField>,
    <FormField key="ab" label="Adjusted By"><input style={S.input} value={f.adjustedBy} onChange={e=>set('adjustedBy',e.target.value)} /></FormField>,
    <FormField key="st" label="Status"><select style={S.select} value={f.status} onChange={e=>set('status',e.target.value)}>{['Draft','Pending','Approved','Rejected'].map(s=><option key={s}>{s}</option>)}</select></FormField>,
    <FormField key="re" label="Reason *" col={2}><input style={S.input} value={f.reason} onChange={e=>set('reason',e.target.value)} /></FormField>,
    <FormField key="no" label="Notes" col={2}><textarea style={{ ...S.textarea, minHeight:60 }} value={f.notes} onChange={e=>set('notes',e.target.value)} /></FormField>,
  ],
});

export default StockAdjustmentPage;
